import { render, staticRenderFns } from "./ComparisonTableWidget.vue?vue&type=template&id=090c33d2"
import script from "./ComparisonTableWidget.vue?vue&type=script&lang=ts"
export * from "./ComparisonTableWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports